import { render, staticRenderFns } from "./UserEditIpRestriction.vue?vue&type=template&id=5f34aa20&scoped=true"
import script from "./UserEditIpRestriction.vue?vue&type=script&lang=ts"
export * from "./UserEditIpRestriction.vue?vue&type=script&lang=ts"
import style0 from "./UserEditIpRestriction.vue?vue&type=style&index=0&id=5f34aa20&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f34aa20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f34aa20')) {
      api.createRecord('5f34aa20', component.options)
    } else {
      api.reload('5f34aa20', component.options)
    }
    module.hot.accept("./UserEditIpRestriction.vue?vue&type=template&id=5f34aa20&scoped=true", function () {
      api.rerender('5f34aa20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/UserEditIpRestriction.vue"
export default component.exports